//import { CdkDragDrop} from '@angular/cdk/drag-drop';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-video-modal',
  standalone: true,
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss']
})
export class VideoModalComponent {
  @Input() videoUrl: any;
  @Input() videoType: any;
  @Output() closeVideoPopup = new EventEmitter<boolean>();
  constructor(private elementRef: ElementRef, private router: Router) {
  }
  
  ngOnInit(): void {
    this.getVideoUrl(this.videoType);
    this.openVideo();
   
  }
  ngAfterViewInit() {
    this.elementRef.nativeElement.querySelector('.fa-regular')
      .addEventListener('click', this.closeVideo.bind(this));
  }

  
  openVideo() {
    var videoHTML = "";
    //if (this.router.url.includes('workspace')) {
    videoHTML = "<div style='position:relative;height:0;padding-bottom:54.332552693208434%'><iframe class='sproutvideo-player' src='" + this.videoUrl + "' style='position:absolute;width:100%;height:100%;left:0;top:0' frameborder='0' allowfullscreen referrerpolicy='no-referrer-when-downgrade' title='Video Player'></iframe></div>";
    //}
    //else {
    //   videoHTML = "<div style='position:relative;height:0;padding-bottom:54.332552693208434%'><iframe class='sproutvideo-player' src='" + this.videoUrl + "' style='position:absolute;width:100%;height:100%;left:0;top:0' frameborder='0' allowfullscreen></iframe></div>";
    //}
    (document.querySelector('#fsModalContent') as HTMLElement).innerHTML = "";
    var newdiv = document.createElement("div");
    newdiv.classList.add("popup-close");
    newdiv.innerHTML = "<div class='tile-button-close' style='text-align:right;'><i class='fa-regular fa-rectangle-xmark' style='color:#1e365c;'></i></div>";
    (document.querySelector('#fsModalContent') as HTMLElement).appendChild(newdiv);

    // Add content
    var newdiv2 = document.createElement("div");
    newdiv2.classList.add("video-content");
    newdiv2.innerHTML = videoHTML;
    (document.querySelector('#fsModalContent') as HTMLElement).appendChild(newdiv2);
    (document.querySelector('#fsModal') as HTMLElement).style.display = "block";
  }
  closeVideo(event:any) {
    this.closeVideoPopup.emit(event);
  }
  getVideoUrl(videoDetails: string) {
    
    if (videoDetails == 'Workspaces')
    {
        this.videoUrl = 'https://videos.sproutvideo.com/embed/4d9fd8b11a18e4c3c4/02571490bf2633ba';

    }
    else if (videoDetails == 'SalesAndDeliveryHub') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/4d9fd8b11a18e1c6c4/148657d29dbc9881';

    }
    else if (videoDetails == 'SmartBank') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/d39fd8b11a18e1c05a/ddef076e7e4087e8';

    }
    else if (videoDetails == 'Assessments') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/d39fd8b11a18e2c35a/a2182d3c9228a116';

    }
    else if (videoDetails == 'TaskLists') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/119fd8b11a18e3c898/dfd40156a530a877';

    }
    else if (videoDetails == 'Applications') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/d39fd8b1181eeacf5a/63f01560c6ac229b';

    }
    else if (videoDetails == 'AskTheExperts') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/119fd8b1181eeac598/ca4a235fdf7f078e';

    }
    else if (videoDetails == 'Search') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/ac9fd8b1181de2c725/d5e4f1640ccda750';

    }
  }
}


